var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lottieContainer",staticClass:"lottie-animation",style:({ width: _vm.width || '100%', height: _vm.height || '100%' })})
}
var staticRenderFns = []

export { render, staticRenderFns }